import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  CreateDoRequestActionOutput,
  DataPage,
} from '../../lib'

import {doDATA_DOWNLOAD_FLOW_METADATA_LIST_SET, doREQUEST_COMPLETE, doREQUEST_ERROR} from '../state'
import {getToken} from './token_fetcher'
import {ProjectDataDownloadFlowMetadata} from '../../model'

export const REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH =
  'REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH'
export const doREQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH =
  createDoRequestAction<RequestProjectDataDownloadFlowMetadataListFetchPayload>(
    REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH,
  )

export const requestProjectDataDownloadFlowMetadataListFetchActionCreators = {
  doREQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH,
}

export interface RequestProjectDataDownloadFlowMetadataListFetchPayload {
  projectId: string
  page: number
}

export interface ProjectDataDownloadFlowMetadataListFetchResponsePayload {
  payload: ProjectDataDownloadFlowMetadata[]
  page: DataPage
}

export function* requestProjectDataDownloadFlowMetadataListFetch({
  payload,
  setRequestResult,
}: CreateDoRequestActionOutput<RequestProjectDataDownloadFlowMetadataListFetchPayload>): SagaIterator {
  debug('saga*requestProjectDataDownloadFlowMetadataListFetch')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        page: v.number().min(0).exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId, page} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-data-download-flow-metadata-list-fetch`,
    accessToken,
    data: {
      projectId,
      page,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-data-download-flow-metadata-list-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doDATA_DOWNLOAD_FLOW_METADATA_LIST_SET({
      projectId,
      items: result.payload,
      page: result.page,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        url: '/v1/web/project-data-download-flow-metadata-list-fetch',
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* ProjectDataDownloadFlowMetadataListFetchSaga() {
  yield takeEvery(
    REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_METADATA_LIST_FETCH,
    requestProjectDataDownloadFlowMetadataListFetch,
  )
}
